import React from 'react';

export enum ResultMode { List = 1, Map }

interface IHeaderContext {
    mode: ResultMode;
    setMode(m: ResultMode): void
}

export const HeaderContext = React.createContext<IHeaderContext>({
    mode: ResultMode.List,
    setMode: (m: ResultMode) => { }
});

export const HeaderContextProvider: React.FC = (props) => {
    const [mode, setMode] = React.useState<ResultMode>(ResultMode.List);

    const contextValue: IHeaderContext = {
        mode: mode,
        setMode: (m: ResultMode) => { setMode(m); }
    };

    return (
        <HeaderContext.Provider value={contextValue}>
            {props.children}
        </HeaderContext.Provider>
    );
};

export default HeaderContext;